module.exports = __webpack_public_path__ + "static/bad-ux-fork-bbd8c29d12876a6f8dbd41e2986b790b.png";